import React, { useEffect, useState } from "react"
import { Input } from "reactstrap"
import { addExpense, getExpenseCat } from "store/expense/actions"
import { useSelector, useDispatch } from "react-redux"
import ConfirmationModal from "./ConfirmationModal"

const ChangeCategory = props => {
  const { categoryId, expenseId } = props
  const [usersList, setUsersList] = useState([])
  const [selectedCat, setSelectedCat] = useState("")
  const [confirmationModal, setConfirmationModal] = useState(false)

  const dispatch = useDispatch()

  const allExpensesCat = useSelector(state => state.expenses.allExpensesCat)

  useEffect(() => {
    if (allExpensesCat && !allExpensesCat.length) {
      dispatch(getExpenseCat())
    }
    // console.log(allExpensesCat)
  }, [])

  useEffect(() => {
    console.log(allExpensesCat)
  }, [allExpensesCat])

  const handleChange = e => {
    console.log(e.target.value)
    setSelectedCat(e.target.value)
    toggle()
  }

  const toggle = () =>
    confirmationModal ? setConfirmationModal(false) : setConfirmationModal(true)

  useEffect(() => {
    setSelectedCat(categoryId)
  }, [categoryId])

  const cancelChange = () => {
    setSelectedCat(categoryId)
    toggle()
  }

  return (
    <>
      <Input
        name="category"
        type="select"
        onChange={e => handleChange(e)}
        value={selectedCat || ""}
        id={categoryId}
      >
        <option value="" disabled>
          Select Category
        </option>
        {allExpensesCat &&
          allExpensesCat.length > 0 &&
          allExpensesCat.map((cat, index) => (
            <option
              key={index}
              value={cat.pkPaymentCategoryID}
              defaultValue={selectedCat === cat.pkPaymentCategoryID}
            >
              {cat.paymentCategoryName}
            </option>
          ))}
      </Input>

      <ConfirmationModal
        toggle={toggle}
        modal={confirmationModal}
        handleCancel={cancelChange}
        categoryId={categoryId}
        newValue={selectedCat}
        expenseId={expenseId}
        
      />
    </>
  )
}

export default ChangeCategory
